import { atom } from "jotai";
import { State } from "./State";
import { fetchBase } from "./BaseApi";

export type SimulationList = {
  simulationId: string;
  title: string;
  summary: string;
  tag: string;
  imageData: string;
  internalUrl: string;
  externalUrl: string;
  isChallenged: boolean;
  expectedTime: number;
};


const uri = "api/simulation-list";

export const fetchSimulationListAtom = atom<State<SimulationList> | null>(null);
export const fetchSimulationList = () => {
  return fetchBase<SimulationList>(uri, fetchSimulationListAtom);
};
